import { useCallback } from 'react'
import { useNavigate } from 'react-router-dom'

export const useNavigateCallback = (...paths: string[]) => {
  const navigate = useNavigate()
  const path = paths.join('/')
  return useCallback(() => navigate(path), [navigate, path])
}
